import React from "react";

const Active = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M18.316 34h-.626c-.834-.135-1.455-.617-2.016-1.215-.47-.502-.978-.967-1.454-1.463-.801-.837-1.768-1.24-2.93-1.225-1.01.013-2.02.01-3.03-.042-1.173-.058-2.265-1.151-2.318-2.321-.048-1.06-.036-2.125-.043-3.186a3.659 3.659 0 00-1.093-2.638c-.637-.645-1.284-1.28-1.92-1.925-1.177-1.188-1.182-2.787-.01-3.973.636-.645 1.28-1.283 1.92-1.925a3.673 3.673 0 001.106-2.665c.006-1.052-.006-2.105.038-3.155.05-1.18 1.151-2.284 2.336-2.336 1.07-.047 2.144-.031 3.217-.042.995-.01 1.848-.37 2.556-1.06.62-.605 1.248-1.2 1.832-1.838 1.216-1.326 3.03-1.314 4.227-.01.557.606 1.165 1.164 1.741 1.751.772.784 1.7 1.164 2.8 1.158a58.12 58.12 0 013.092.043c1.174.058 2.261 1.145 2.319 2.32.05 1.03.048 2.062.043 3.092-.005 1.101.374 2.03 1.158 2.801.506.496.989 1.015 1.506 1.5.605.567 1.097 1.192 1.237 2.037v.625c-.137.846-.63 1.471-1.233 2.039-.532.499-1.036 1.027-1.55 1.544-.742.744-1.116 1.637-1.12 2.691-.002 1.052.008 2.105-.041 3.155-.054 1.17-1.149 2.266-2.317 2.32-1.03.048-2.062.045-3.093.04-1.102-.005-2.028.38-2.8 1.162-.511.52-1.044 1.02-1.543 1.551-.552.588-1.17 1.055-1.991 1.19zm-2.457-13.777l-3.95-3.951-1.82 1.822 5.826 5.81 9.98-9.987-1.855-1.888c-2.701 2.704-5.423 5.43-8.181 8.194z"
            fill={fill}
        />
    </svg>
);

export default Active;
